<template>
    <div class="employerDetailsClient">

        <!-- Main Body Content area -->
        <div class="o-main-content-area">
            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
              <div class="col-md-5">
                <p class="u-back"><router-link to="/employerJobList"><i class="fa fa-chevron-left"></i> Back</router-link></p>
              </div>
              <div class="col-md-7 text-right" v-if="userRoleSlug=='employer-admin'">
                <ul class="o-filter-area">
                  <li><a @click="gotoEditEmployer()" class="c-common-btn c-common-btn--inverse-icon-green"><i class="fa fa-pencil" aria-hidden="true"></i> Edit</a></li>
                </ul>
              </div>
              <div class="col-md-12 c-user">
                <div class="c-user__profile-pic u-mar-right-10">
                    <img v-if="detailEmployer.image=='' || detailEmployer.image==null" src="static/assets/images/user1.png" />
                    <img v-else :src="detailEmployer.image" />
                </div>
                <div class="c-user__profile-details">
                  <h4 class="h1">{{detailEmployer?detailEmployer.name:''}}</h4>
                  <p>Email ID: {{detailEmployer?detailEmployer.email:''}}</p>
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <!-- /Heading Section -->
            <!-- Main Body Content area -->
            <!-- <div class="c-common-space c-responsive-fixwidth">
              <div class="c-common-box-shadow c-employer-box-content clearfix o-skillset-area">
                <div class="col-sm-12">
                  <div class="c-common-space c-responsive-fixwidth">
                    <div class="clearfix o-employer-a">
                      <h3>Contact Persons:</h3>
                        <div v-for="employer in detailEmployer.employer_users" class="row">
                          <div class="col-sm-3">
                            <h5>Contact Person Name</h5>
                            <p>
                              {{employer.user.first_name}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Email</h5>
                            <p>
                              {{employer.user.email}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Phone</h5>
                            <p v-for="phone in employer.user.phones">
                              {{phone.phone_number}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Client Access</h5>
                            <p>
                              <span>---</span>
                            </p>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <div class="c-common-space c-responsive-fixwidth">
              <div class="c-common-box-shadow c-employer-box-content clearfix o-skillset-area">
                <div class="col-sm-12">
                  <div class="c-common-space c-responsive-fixwidth">
                    <div class="clearfix o-employer-a">
                      <h3>Phone & Fax:</h3>
                        <div class="row">
                          <div class="col-sm-3">
                            <h5>Primary Phone No.</h5>
                            <p v-for="phone in detailEmployer.phones" v-if="phone.label=='Primary phone'">
                                {{phone.phone_number}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Secondary Phone No.</h5>
                            <p v-for="phone in detailEmployer.phones" v-if="phone.label=='Secondary phone'">
                                {{phone.phone_number}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Cell Phone</h5>
                            <p v-for="phone in detailEmployer.phones" v-if="phone.label=='Cell phone'">
                                {{phone.phone_number}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Fax</h5>
                            <p v-for="phone in detailEmployer.phones" v-if="phone.label=='Fax'">
                                {{phone.phone_number}}
                            </p>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="c-common-space c-responsive-fixwidth">
              <div class="c-common-box-shadow c-employer-box-content clearfix o-skillset-area">
                <div class="col-sm-12">
                  <div class="c-common-space c-responsive-fixwidth">
                    <div class="clearfix o-employer-a">
                      <h3>Address:</h3>
                        <div class="row">
                          <div class="col-sm-3">
                            <h5>Street</h5>
                            <p v-if="detailEmployer.addresses && detailEmployer.addresses.length>0">
                              {{detailEmployer.addresses[0].address}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>City</h5>
                            <p v-if="detailEmployer.addresses && detailEmployer.addresses.length>0">
                              {{detailEmployer.addresses[0].municipality}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>State</h5>
                            <p v-if="detailEmployer.addresses && detailEmployer.addresses.length>0">
                              {{detailEmployer.addresses[0].state_province}}
                            </p>
                          </div>
                          <div class="col-sm-3">
                            <h5>Zip</h5>
                            <p v-if="detailEmployer.addresses && detailEmployer.addresses.length>0">
                              {{detailEmployer.addresses[0].postcode}}
                            </p>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- HR Policy Config (employer-admin only) -->
            <employer-hr-config
                v-if="userRoleSlug=='employer-admin'"
                :employerId="companyId"
            ></employer-hr-config>

        </div>
        <!-- /Main Body Content area -->
    </div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    import {
        global
    } from '../../global.js';
    import employerHrConfig from './employerHrConfig.vue';

    export default {
        components: {
            employerHrConfig,
        },
        data() {
            return {
                detailEmployer:[],
            }
        },

        computed: {
            ...mapGetters({
                userToken: 'userToken',
                companyId: 'companyId',
                userRoleSlug: 'userRoleSlug',
            })
        },
        methods: {
            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },
            getDate(str) {
                return dateTimeConvert.localDate(str);
                //var date = str.split(" ");
                //return date[0];
            },
            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
                //var time = dateTimeConvert.extractTimeOnly(dateTime);
                //time = dateTimeConvert.convertTo12Hours(time);
                //return time;
            },
            empDetails() {
                this.getBaseURL = global[0].IMAGE_URL;
                this.$Progress.start();
                service.get('employer/' + this.companyId, {
                    'Authorization': this.userToken,
                }).
                then((res) => {
                    this.$Progress.finish();
                    this.detailEmployer = res.data.result;

                }).catch((err) => {
                    console.log(err);
                });
            },
            backToEmployerList() {
                this.$router.push({
                    path: `/clientEmployersList`
                });
            },
            gotoEditEmployer() {
                this.$router.push({
                    path: `/editEmployerClient/`+btoa(this.companyId)
                });
            },
            phoneNumberCheck(phone_number, type) {
                let self = this;
                let primaryPhone = "";
                if (phone_number) {
                    phone_number.forEach(function(employerphone) {
                        if (employerphone.label == type) {
                            //console.log(employerphone.label);
                            primaryPhone = employerphone.phone_number;
                        }
                    });
                }
                return primaryPhone;

            },

        },
        created() {
            this.empDetails();

        }
    }

</script>


